function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function (e, t) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports["v-clipboard"] = t() : e["v-clipboard"] = t();
}(this, function () {
  return function (e) {
    function t(n) {
      if (r[n]) return r[n].exports;
      var o = r[n] = {
        i: n,
        l: !1,
        exports: {}
      };
      return e[n].call(o.exports, o, o.exports, t), o.l = !0, o.exports;
    }

    var r = {};
    return t.m = e, t.c = r, t.i = function (e) {
      return e;
    }, t.d = function (e, r, n) {
      t.o(e, r) || Object.defineProperty(e, r, {
        configurable: !1,
        enumerable: !0,
        get: n
      });
    }, t.n = function (e) {
      var r = e && e.__esModule ? function () {
        return e.default;
      } : function () {
        return e;
      };
      return t.d(r, "a", r), r;
    }, t.o = function (e, t) {
      return Object.prototype.hasOwnProperty.call(e, t);
    }, t.p = "/dist/", t(t.s = 0);
  }([function (e, t, r) {
    "use strict";

    Object.defineProperty(t, "__esModule", {
      value: !0
    });

    var n = function n(e) {
      var t = void 0;
      if ("string" != typeof e) try {
        t = JSON.stringify(e);
      } catch (e) {
        throw "Failed to copy value to clipboard. Unknown type.";
      } else t = e;
      var r = document.createElement("textarea");

      if (r.value = t, r.setAttribute("readonly", ""), r.style.cssText = "position:fixed;pointer-events:none;z-index:-9999;opacity:0;", document.body.appendChild(r), navigator.userAgent.match(/ipad|ipod|iphone/i)) {
        r.contentEditable = !0, r.readOnly = !0;
        var n = document.createRange();
        n.selectNodeContents(r);
        var o = window.getSelection();
        o.removeAllRanges(), o.addRange(n), r.setSelectionRange(0, 999999);
      } else r.select();

      var a = !1;

      try {
        a = document.execCommand("copy");
      } catch (e) {
        console.warn(e);
      }

      return document.body.removeChild(r), a;
    };

    t.default = {
      install: function install(e) {
        e.prototype.$clipboard = n;

        var t = function (e) {
          return function () {
            return "$" + e++;
          };
        }(1),
            r = {},
            o = function o(e) {
          e && (r[e] = null, delete r[e]);
        },
            a = function a(e) {
          var n = t();
          return r[n] = e, n;
        };

        e.directive("clipboard", {
          bind: function bind(e, t) {
            var o = t.arg,
                i = t.value;

            switch (o) {
              case "error":
                var c = a(i);
                return void (e.dataset.clipboardErrorHandler = c);

              case "success":
                var d = a(i);
                return void (e.dataset.clipboardSuccessHandler = d);

              default:
                var l = function l(o) {
                  if (t.hasOwnProperty("value")) {
                    var a = {
                      value: "function" == typeof i ? i() : i,
                      event: o
                    },
                        c = n(a.value) ? e.dataset.clipboardSuccessHandler : e.dataset.clipboardErrorHandler,
                        d = r[c];
                    d && d(a);
                  }
                },
                    u = a(l);

                return e.dataset.clipboardClickHandler = u, void e.addEventListener("click", r[u]);
            }
          },
          unbind: function unbind(e) {
            var t = e.dataset,
                n = t.clipboardSuccessHandler,
                a = t.clipboardErrorHandler,
                i = t.clipboardClickHandler;
            o(n), o(a), i && (e.removeEventListener("click", r[i]), o(i));
          }
        });
      }
    };
  }]);
});